import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

export default function VIewInvestmentEnquiry() {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const getCategoryData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/investment/${id}`,
      );
      if (res.status === 200) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
      setLoader(true);
    }
  };
  useEffect(() => {
    if (id) getCategoryData();
  }, [id]);

  const formatLabel = (text) => {
    if (!text) return "";

    return text
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const customLabels = {
    ifsc: "IFSC Code",
    pan: "PAN Number",
    dob: "Date of Birth",
    nominee_dob: "Nominee Date of Birth",
    account_no: "Account Number",
    pin: "Pincode",
    ckyc: "CKYC Number",
  };

  if (loader) {
    return (
      <div className="page-wrapper page-settings">
        <div className="error">
        </div>
      </div>
    );
  }
  return (
    <>
      {!loader && (
        <div className="main-content">
          <div className="page-wrapper page-settings">
            <div className="content">
              {/* Breadcrumb and Header Section with Card Shadow */}
              <div
                className="mb-4"
                style={{
                  background: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                }}
              >
                       <div className="content-page-header content-page-headersplit">
                  <h5>View Investment Enquiry</h5>
                  <div className="list-btn">
                    <Link to="/investment-enquiry" className="btn btn-cancel">
                      <i className="fas fa-arrow-left me-2"></i>
                      Back
                    </Link>
                  </div>
                </div>
                <nav
                  aria-label="breadcrumb"
                  style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Dashboard</Link>/
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/investment-enquiry">Investment Enquiry</Link> /
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      View Investment Enquiry
                    </li>
                  </ol>
                </nav>
         
              </div>

              {/* Personal Information Section with Card Shadow */}
              <div
                className="mb-4"
                style={{
                  background: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                }}
              >
                <h4
                  style={{
                    marginBottom: "20px",
                    borderBottom: "2px solid #e6f6f5",
                    paddingBottom: "12px",
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#006e82",
                  }}
                >
                  Personal Information
                </h4>
                <div className="row g-3">
                  {[
                    "title",
                    "name",
                    "pan",
                    "app_code",
                    "email",
                    "alt_email",
                    "user_name",
                    "mobile",
                    "dob",
                    "marital_status",
                    "relationship_manager",
                    "referred_by",
                  ].map((field) => (
                    <div key={field} className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                          {customLabels[field] || formatLabel(field)}
                        </label>
                        <input
                          type={field.includes("dob") ? "date" : "text"}
                          value={
                            field.includes("dob") && data[field]
                              ? new Date(data[field]).toISOString().split("T")[0]
                              : data[field] || ""
                          }
                          disabled
                          className="form-control"
                          style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Residential Address Section with Card Shadow */}
              <div
                className="mb-4"
                style={{
                  background: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                }}
              >
                <h4
                  style={{
                    marginBottom: "20px",
                    borderBottom: "2px solid #e6f6f5",
                    paddingBottom: "12px",
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#006e82",
                  }}
                >
                  Residential Address
                </h4>
                <div className="row g-3">
                  {["country", "state", "city", "address", "pin"].map(
                    (field) => (
                      <div key={field} className="col-lg-4 col-md-6">
                        <div className="form-group">
                          <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                            {customLabels[field] || formatLabel(field)}
                          </label>
                          <input
                            type="text"
                            value={data[field] || ""}
                            disabled
                            className="form-control"
                            style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                          />
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>

              {/* Bank Details Section with Card Shadow */}
              <div
                className="mb-4"
                style={{
                  background: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                }}
              >
                <h4
                  style={{
                    marginBottom: "20px",
                    borderBottom: "2px solid #e6f6f5",
                    paddingBottom: "12px",
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#006e82",
                  }}
                >
                  Bank Details
                </h4>
                <div className="row g-3">
                  {[
                    "bank_name",
                    "account_holder_name",
                    "account_no",
                    "account_type",
                    "ifsc",
                    "branch",
                  ].map((field) => (
                    <div key={field} className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                          {customLabels[field] || formatLabel(field)}
                        </label>
                        <input
                          type="text"
                          value={data[field] || ""}
                          disabled
                          className="form-control"
                          style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Nominee Details Section with Card Shadow */}
              <div
                className="mb-4"
                style={{
                  background: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                }}
              >
                <h4
                  style={{
                    marginBottom: "20px",
                    borderBottom: "2px solid #e6f6f5",
                    paddingBottom: "12px",
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#006e82",
                  }}
                >
                  Nominee Details
                </h4>
                <div className="row g-3">
                  {[
                    "nominee_name",
                    "nominee_type",
                    "nominee_dob",
                    "nominee_share",
                    "nominee_relation",
                    "nominee_address",
                  ].map((field) => (
                    <div key={field} className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                          {customLabels[field] || formatLabel(field)}
                        </label>
                        <input
                          type={field.includes("dob") ? "date" : "text"}
                          value={
                            field.includes("dob") && data[field]
                              ? new Date(data[field]).toISOString().split("T")[0]
                              : data[field] || ""
                          }
                          disabled
                          className="form-control"
                          style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* KYC & FATCA Section with Card Shadow */}
              <div
                className="mb-4"
                style={{
                  background: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                }}
              >
                <h4
                  style={{
                    marginBottom: "20px",
                    borderBottom: "2px solid #e6f6f5",
                    paddingBottom: "12px",
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#006e82",
                  }}
                >
                  KYC & FATCA
                </h4>
                <div className="row g-3">
                  {[
                    "gross_annual_income",
                    "individual_type",
                    "non_individual_type",
                    "nationality",
                    "gender",
                    "place_of_birth",
                    "country_of_birth",
                    "father_name",
                    "mother_name",
                    "spouse",
                    "ckyc",
                  ].map((field) => (
                    <div key={field} className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                          {customLabels[field] || formatLabel(field)}
                        </label>
                        <input
                          type="text"
                          name={field}
                          value={data[field] || ""}
                          disabled
                          className="form-control"
                          style={{ background: "#f9fafb", border: "1px solid #E3E3E3" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
